// extracted by mini-css-extract-plugin
export var actionButton = "_ip-t";
export var buttonContainer = "_ip-0";
export var buttonContainer2 = "_ip-1";
export var buttonSection = "_ip-2";
export var details = "_ip-3";
export var dropdownItem = "_ip-5";
export var dropdownItemsContainer = "_ip-4";
export var fileInput = "_ip-r";
export var headerButton = "_ip-6";
export var icon = "_ip-7";
export var input = "_ip-8";
export var macroListItem = "_ip-9";
export var mainContent = "_ip-a";
export var microText = "_ip-b";
export var modal = "_ip-w";
export var optionsButton = "_ip-c";
export var paperclip = "_ip-s";
export var pillContent = "_ip-d";
export var preview = "_ip-e";
export var preview2 = "_ip-f";
export var quillEditor = "_ip-q";
export var selectedMacro = "_ip-g";
export var sidebar = "_ip-h";
export var sidebarHeader = "_ip-j";
export var sidebarList = "_ip-i";
export var sidebarListItem = "_ip-k";
export var sidebarSearch = "_ip-l";
export var snoozeDurationWrapper = "_ip-v";
export var statusPillContainer = "_ip-m";
export var tagsContainer = "_ip-n";
export var unselectedMacro = "_ip-o";
export var variable = "_ip-u";
export var wrapper = "_ip-p";